import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { ConsumidorModel, ConsumidorService } from '../shared/';
import { Component, OnDestroy, OnInit } from '@angular/core';

import {
  ParametrosService, NbpConfirmComponent,
  MunicipioModel, MunicipioService
} from '../../../shared';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
  selector: 'app-consumidor-detalhar',
  templateUrl: './consumidor-detalhar.component.html',
  styleUrls: []
})
export class ConsumidorDetalharComponent implements OnInit, OnDestroy {

  public consumidor: ConsumidorModel = new ConsumidorModel();
  public consumidorChange: Subject<ConsumidorModel> = new Subject<ConsumidorModel>();
  public unsubConsumidor: Subscription;
  public unsubMunicipio: Subscription;
  public municipio: MunicipioModel = new MunicipioModel('');
  public cpf = 0;
  public instituicaoDesabilitada: false;

  constructor(private readonly consumidorService: ConsumidorService,
    private readonly municipioService: MunicipioService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly ngbModalService: NgbModal,
    private readonly parametrosService: ParametrosService) { }

  ngOnInit() {

    // ESSE É UM PARAMETRO GLOBAL UTILIZADO NO MODULO DE DUVIDAS PARA INDICAR QUAL ABA DEVE VIR DADO O FOCO NO COMPONENTE
    this.parametrosService.contextoConsumidor = ParametrosService.CIDADAO;

    this.consumidor = this.consumidorService.getConsumidorModel();
    this.municipioService.getMunicipiosIBGE(this.consumidor.codigoMunicipioIBGE);

    this.unsubConsumidor = this.consumidorService.consumidorChange
      .subscribe(
      (_consumidor: ConsumidorModel) => {
        this.municipioService.getMunicipiosIBGE(_consumidor.codigoMunicipioIBGE);
      });

    // OBSERVADOR DA CONSULTA DE MUNICIPIO PELO CODIGO DO IBGE
    this.unsubMunicipio = this.municipioService.muncipioChange
      .subscribe(
      (municipio) => {
        this.municipio = municipio;
      });

  }

  ngOnDestroy() {
    this.unsubMunicipio.unsubscribe();
    this.unsubConsumidor.unsubscribe();
  }

  onDetalharClick() {
    this.router.navigate(['/consumidor/dados_consumidor']);
  }

  onDescadastrarConsumidor() {
    const confirmModal = this.ngbModalService.open(NbpConfirmComponent, { size: 'lg' });
    confirmModal.componentInstance.mensagem = 'Você tem certeza que deseja descadastrar-se da Campanha Nota Premiada Bahia?';

    const unsubConfirm = confirmModal.componentInstance.userConfirmChange
      .subscribe(
      (userConfirm) => {
        if (userConfirm) {
          const dataAtual = moment().format('YYYY-MM-DD[T]HH:mm:ss.SSS');

          this.consumidor.dataExclusao = dataAtual;
          this.consumidorService.putConsumidorDescadastrar(this.consumidor);

          unsubConfirm.unsubscribe();
        }
      }
      );
  }

  onAlteraSenha() {
    this.consumidorService.setConsumidorModel(this.consumidor);
    this.consumidorService.editSenhaMode = true;
    this.router.navigate(['/consumidor/alterar_senha_logado']);
  }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-detalhar/consumidor-detalhar.component.ts